/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
import { ControlTable } from "../../../components/Table";
import { classnames } from "../../../utils/text";
import { isVerticalImg } from "../../../utils/image";
import { CARD_DATA, CARD_TYPE } from "../../../constants/CARD_DATA";
import { translation } from "../../../utils/translator";
import Badge from "../../../components/Badge";
import defaultCardImage from "../../../assets/images/bank-card-images/default-card-img.png"
import Filters from "../../../components/Filters";
import useForm from "../../../hooks/useForm";
import { getDay } from "../../../utils/date";
import { getStatisticsTradeSummaries } from "../../../apis/finances/statistics";
import { getParams } from "../../../utils/params";
import { cardName } from "../../../utils/account-name";
import { useHistory } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link"
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

const FundsCard = (props) => {
  const history = useHistory()
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [fields] = useState([
    {
      title: '신용카드', key: '', onValue: (value, field, data) => {
        const { cardImg, cardCompany, cardNo, orgCd } = data
        return (
          <>
            <div
              className={classnames("card-img-wrap", {
                vertical: isVerticalImg(cardImg),
              })}
            >
              <img src={cardImg || defaultCardImage} alt={data.cardName} onError={(e) => e.target.src = defaultCardImage} />
            </div>
            <Badge
              className={classnames("card-type-badge", {
                vertical: isVerticalImg(cardImg),
              })}
              color={orgCd === 'card' ? "secondary" : 'warning'}
              size="sm"
              label={translation(CARD_TYPE, orgCd)}
            />
            <span
              className="card-name"
            >
              {cardName(cardCompany || data.cardName, cardNo)}
            </span>
          </>
        );
      }
    },
    {
      title: '카드명',
      key: 'cardName'
    },
    {
      title: '별칭',
      key: 'nickName'
    },
    {
      title: '총 승인금액',
      key: 'useAmtSum',
      type: 'comma',
      className: 'color-red-100'
    }
  ])
  const [list, setList] = useState([])
  const [filters] = useState([
    {
      title: '조회기간',
      key: 'range.tradeDate',
      type: 'customdatepicker'
    }
  ])
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions))
    {
      const permission = permissions.find(p => p.code === 'FUND_CARD_HISTORY')
      setTargetPermission(permission)
      if (isEmpty(permission))
      {
        permissionCheck(history, "FUND_CARD_HISTORY")
      }
    }
  }, [permissions])

  const {
    form,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
  } = useForm(
    {
      range: {
        tradeDate: [getDay(7), getDay()]
      },
      limit: 999
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, [])

  const submit = (_params) => {
    getStatisticsTradeSummaries(getParams(_params))
      .then((res) => {
        const { cardSummary } = res.data
        setList(cardSummary.purchaseCards.map((card) => ({
          ...card,
          cardCompany: translation(CARD_DATA, card.cardCd, 'code', 'name')
        })))
      })
  }
  // 

  const handleRowClick = (data) => {
    history.push('/funds/card-detail?tab=purchases', {
      date: form.range.tradeDate,
      data
    })
  }


  return (
    !isEmpty(targetPermission) && (
      <>
        <PageHeader title={"신용카드 목록"} />
        <Filters
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          title="사용 중인 신용카드 목록"
          fields={fields}
          list={list}
          onSelect={handleRowClick}
          noDataText={
            <Link to="/manager/financial#section-three" className="text-align-center">
              <p className="color-gray-5 nowrap">
                {"관리자 > 금융 정보 자동 수집 > 신용카드 매입 정보를 연동해주세요."}
              </p>
              <p className="color-main-80 font-size-15">
                {"클릭시 해당 메뉴로 이동합니다."}
              </p>
            </Link>
          } />
      </>
    )
  );
};

export default FundsCard;
